<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="服务名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>

      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1"> 启用 </a-radio-button>
          <a-radio-button :value="0"> 禁用 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="服务图标" prop="icon">
        <file-upload
          type="image"
          :defaultList="form.icon ? [form.icon] : []"
          :file="form.icon"
          @input="getImg($event, 'icon')"
          :count="1"
          autoCropHeight="80"
          :isUpload="false"
          autoCropWidth="80"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="服务图片" prop="pic">
        <file-upload
          type="image"
          :defaultList="form.pic ? [form.pic] : []"
          :file="form.pic"
          @input="getImg($event, 'pic')"
          :count="1"
          autoCropHeight="80"
          :isUpload="false"
          autoCropWidth="80"
        ></file-upload>
      </a-form-model-item>

      <a-form-model-item label="参考价格说明" prop="sort">
        <a-input v-model="form.referenceData" placeholder="请输入" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item label="单位" prop="sort">
        <a-input v-model="form.unitVal" placeholder="请输入" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入" :maxLength="150" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj, getServelist } from '@/api/maintenance/serviceItem/index.js'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        name: undefined,
        pic: undefined,
        icon: undefined,
        remark: undefined,
        parentId: 0,
        status: 1,
        sort: 99,
        referenceData: undefined,
        unitVal: undefined,
      },
      isShow: false,
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      inputVisible: false,
      inputVisibles: false,
      showLoading: false,
      rules: {
        name: [{ required: true, message: '请输入的服务名称', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传服务图片', trigger: 'blur' }],
        icon: [{ required: true, message: '请服务图片', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        optionalUnit: [{ required: true, message: '请添加单位', trigger: 'blur' }],
        referenceData: [{ required: true, message: '请输入参考价格说明', trigger: 'blur' }],
        serviceId: [{ required: true, message: '请选择服务类目', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      serveList: [],
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 取消按钮
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        name: undefined,
        pic: undefined,
        icon: undefined,
        remark: undefined,
        parentId: 0,
        status: 1,
        sort: 99,
        referenceData: undefined,
        unitVal: undefined,
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd(e) {
      console.log(e, 222)
      this.reset()
      this.form.serviceId = e
      this.getServe()
      this.open = true
      this.formTitle = '添加维修服务项'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.getServe()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改维修服务项'
      })
    },
    getServe() {
      getServelist().then((response) => {
        this.serveList = response.data.records
      })
    },
    handleChange() {},
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
